/* =============================================================================
   RDG 2026-09-10 — CARROUSEL D'IMAGES SUR LES CARTES DE COLLECTION

   Demande de Lucien : « pouvoir scroller pour voir les autres images du produit,
   avec une mini barre en bas de l'image pour montrer qu'on glisse ». Reference
   fournie : deux vignettes portant un trait court en bas a gauche.

   POURQUOI DU DEFILEMENT NATIF ET PAS UN GLISSEUR JS. Les vues vivent DANS le
   lien <a> de la carte. Un glisseur pilote a la souris (pointerdown + transform)
   aurait fallu distinguer un glissement d'un appui, et un faux positif envoie la
   cliente sur la fiche produit au milieu de son geste. Le defilement natif
   (overflow-x + scroll-snap) ne pose pas la question : le navigateur sait deja
   qu'un doigt qui fait defiler n'emet pas de clic. Zero risque sur le lien.

   CE FICHIER NE FAIT QUE TROIS CHOSES :
     1. hydrater les vues differees au premier contact (elles n'ont pas de src) ;
     2. faire suivre la barre, EN CONTINU, au fil du defilement ;
     3. corriger le `sizes` des cartes PLEINE LARGEUR (voir plus bas).

   FLECHES D'ORDINATEUR RETIREES le 10/09 a la demande de Lucien (elles avaient
   ete ajoutees le matin meme, puis debarrassees de leur cadre, puis supprimees).
   Le defilement se fait donc au doigt, au trackpad ou a la molette horizontale.

   TOUT EST DELEGUE AU DOCUMENT, sans initialisation par carte. C'est voulu :
   `facets.js` REMPLACE la grille de produits a chaque filtre (l. 694, il reecrit
   `newProducts`). Une init par carte serait perdue a ce moment-la, en silence.
   La delegation, elle, survit — il n'y a rien a reinitialiser.
   ============================================================================= */
(function () {
  'use strict';

  var SEL = '.rdg-carrousel';
  var PISTE = '[data-rdg-piste]';

  /* --- 1. Hydratation des vues differees ---------------------------------- */
  /* Les vues 3 et suivantes sont rendues SANS src (data-rdg-src seulement). Sur
     une page de collection il y a 29 cartes : les charger d'office aurait ajoute
     une centaine d'images que personne ne regarde. Les vues 1 et 2 gardent le
     comportement d'aujourd'hui, donc a l'arrivee sur la page le poids est
     RIGOUREUSEMENT INCHANGE. */
  function hydrater(carrousel) {
    if (!carrousel || carrousel.dataset.rdgHydrate === '1') return;
    carrousel.dataset.rdgHydrate = '1';
    var differees = carrousel.querySelectorAll('img[data-rdg-src]');
    for (var i = 0; i < differees.length; i++) {
      var img = differees[i];
      if (img.dataset.rdgSrcset) img.srcset = img.dataset.rdgSrcset;
      img.src = img.dataset.rdgSrc;
      img.removeAttribute('data-rdg-src');
      img.removeAttribute('data-rdg-srcset');
    }
  }

  /* --- 2. La barre, EN CONTINU ----------------------------------------------- */
  /* Lucien, 10/09 : « possible que la barre soit fluide et pas saccadee quand on
     switch entre les images ».

     CE QUI LA RENDAIT SACCADEE : on ARRONDISSAIT la position a la vue la plus
     proche, et une transition CSS de .3s rattrapait ensuite l'ecart. La barre ne
     suivait donc pas le doigt — elle sautait d'un cran, en retard.

     Desormais on pose le rapport BRUT `scrollLeft / largeur`, decimales
     comprises, et la transition est retiree cote CSS. Le segment colle au doigt
     image par image, et le scroll-snap l'amene naturellement sur un cran entier
     quand le geste se termine. Aucune animation a nous : c'est le defilement qui
     mene, et c'est ce qui fait la fluidite. */
  function majBarre(carrousel) {
    var piste = carrousel.querySelector(PISTE);
    /* La barre n'est plus soeur du carrousel depuis qu'elle est sortie de
       l'image (retour de Lucien du 10/09) : elle vit dans le wrapper de la
       carte. On remonte donc a la CARTE, pas au conteneur image — un
       `parentNode.querySelector` ne la trouvait plus, et la barre serait restee
       figee sans qu'aucune erreur ne le dise. */
    var carte = carrousel.closest('.hdt-card-product');
    var barre = carte && carte.querySelector('.rdg-carrousel__barre');
    if (!piste || !barre) return;
    var largeur = piste.clientWidth;
    if (!largeur) return;
    var n = piste.children.length;
    var x = piste.scrollLeft / largeur;          /* brut, decimales comprises */
    if (x < 0) x = 0;                            /* rebond elastique iOS */
    if (x > n - 1) x = n - 1;
    /* 28/10 — les fleches (fiche 74) : la premiere vue n'a pas de « precedente »,
       la derniere pas de « suivante ». Le CSS lit cet attribut ; sans lui (carte
       jamais touchee), on est au debut. */
    var bord = x < 0.05 ? 'debut' : (x > n - 1.05 ? 'fin' : 'milieu');
    if (carte.getAttribute('data-rdg-x') !== bord) carte.setAttribute('data-rdg-x', bord);
    /* Arrondi au centieme : inutile de reecrire la variable a chaque
       sous-pixel, et ca evite de salir le style en ligne. */
    barre.style.setProperty('--rdg-vue', Math.round(x * 100) / 100);
  }

  /* --- 3. La resolution des cartes PLEINE LARGEUR ---------------------------- */
  /* Lucien, 10/09 : « possibilite que l'image pleine largeur soit en bonne
     resolution ? ». Oui, et c'etait un vrai defaut.

     LE DEFAUT, EN CHIFFRES. L'attribut `sizes` du theme se termine par
     `calc((100vw - 30px - 1 * 3px) / 2)` — il decrit une grille a DEUX colonnes,
     soit 171px sur un ecran de 375. Mais le rythme editorial fait passer une
     carte sur dix-huit en PLEINE LARGEUR : elle s'affiche sur 375px. Le
     navigateur choisissait donc une image taillee pour 171px. Sur un iPhone
     (densite 3) il faut 1125px et il en telechargeait 513 — moins de la moitie.

     POURQUOI EN JS ET NON EN LIQUID. La position pleine largeur est un
     `nth-child(18n+11)` / `nth-child(18n)` sur les enfants REELS de la grille,
     et la boucle Liquid y insere parfois des bannieres (`media_overlay`) : le
     `forloop.index` et l'index DOM peuvent diverger, et le `sizes` serait pose
     sur la mauvaise carte sans que rien ne le signale. Mesurer la largeur
     RENDUE ne peut pas se tromper — c'est la meme lecon que « mesurer le rendu,
     pas lire le CSS ».

     ET POURQUOI IL FAUT LE REFAIRE APRES UN FILTRE. `facets.js` reecrit le
     `sizes` de TOUTES les images de carte apres un rendu (l. 564 et 694) avec la
     valeur de la grille courante : notre correction serait effacee en silence.
     D'ou l'observateur, arme sur la grille seule. */
  function ajusterResolution() {
    var grille = document.querySelector('[id^="products-"]');
    if (!grille) return;
    var largeurGrille = grille.clientWidth;
    if (!largeurGrille) return;
    var cartes = grille.querySelectorAll('.hdt-card-product');
    for (var i = 0; i < cartes.length; i++) {
      /* 0,9 et non 1 : la carte pleine largeur occupe toute la piste, les
         vignettes a deux colonnes en occupent la moitie. Aucune ambiguite,
         mais on laisse la marge des arrondis de sous-pixel. */
      var largeurCarte = cartes[i].getBoundingClientRect().width;
      var pleine = largeurCarte >= largeurGrille * 0.9;
      /* 10/09 (2e passe) : on ne corrige plus SEULEMENT les cartes pleine
         largeur. Le rythme editorial PC alterne des rangees de 3 (span 4,
         472px a 1440) et de 4 (span 3, 352px) : deux largeurs sur la meme
         page, qu'un seul attribut ne peut pas decrire. Le Liquid annonce la
         plus GRANDE ; ici on REDUIT les etroites a leur boite reelle.
         Ce sens est le seul sur — reduire un `sizes` ne redemande jamais
         d'image, l'augmenter apres coup en redemande une. */
      var vues = cartes[i].querySelectorAll('.rdg-carrousel__vue, .hdt-card-product__media--main, .hdt-card-product__media--hover');
      for (var j = 0; j < vues.length; j++) {
        if (pleine) {
          vues[j].setAttribute('sizes', '100vw');
        } else if (largeurCarte > 0) {
          vues[j].setAttribute('sizes', Math.round(largeurCarte) + 'px');
        }
      }
    }
  }

  /* Au chargement : les cartes pleine largeur tombent aux positions 11, 18, 29…
     donc TOUJOURS sous la ligne de flottaison. Un script `defer` passe donc
     avant que leurs images differees ne soient demandees — la correction arrive
     a temps, sans double telechargement. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ajusterResolution);
  } else {
    ajusterResolution();
  }
  /* Rotation du telephone : la grille change de largeur, la carte pleine
     largeur aussi. */
  window.addEventListener('resize', function () {
    clearTimeout(window.__rdgRes);
    window.__rdgRes = setTimeout(ajusterResolution, 200);
  }, { passive: true });

  /* Apres un filtre, un tri ou un « voir plus » : la grille est remplacee et
     `facets.js` repose SON `sizes`. On repasse derriere. */
  if (window.MutationObserver) {
    var grilleObs = document.querySelector('[id^="products-"]');
    if (grilleObs) {
      new MutationObserver(function () {
        clearTimeout(window.__rdgObs);
        window.__rdgObs = setTimeout(ajusterResolution, 60);
      }).observe(grilleObs, { childList: true, subtree: true });
    }
  }

  /* --- 3. Les evenements, tous delegues ------------------------------------ */

  /* Survol / contact : on hydrate. `pointerover` couvre la souris ET le stylet ;
     `touchstart` couvre le doigt, qui n'emet pas toujours pointerover avant le
     premier defilement. Passif : on ne prend jamais la main sur le geste. */
  document.addEventListener('pointerover', function (e) {
    var c = e.target.closest && e.target.closest(SEL);
    if (c) hydrater(c);
  }, { passive: true });

  document.addEventListener('touchstart', function (e) {
    var c = e.target.closest && e.target.closest(SEL);
    if (c) hydrater(c);
  }, { passive: true });

  /* Le defilement ne remonte pas (scroll ne bouillonne pas) : on ecoute en
     phase de CAPTURE, seule facon de l'attraper depuis le document. */
  var enAttente = false;
  document.addEventListener('scroll', function (e) {
    var cible = e.target;
    if (!cible || !cible.matches || !cible.matches(PISTE)) return;
    var c = cible.closest(SEL);
    if (!c) return;
    hydrater(c);
    if (enAttente) return;
    enAttente = true;
    requestAnimationFrame(function () {
      enAttente = false;
      majBarre(c);
    });
  }, true);

  /* --- 4. Les fleches et les coloris (28/10, fiche 74) ---------------------- */
  /* Une fleche fait glisser la piste d'une vue, en douceur : c'est le meme
     defilement natif que le doigt, donc le scroll-snap, la barre et
     l'hydratation suivent sans rien de plus. En CAPTURE et avec
     stopPropagation : le delegue de la carte ne doit pas y voir un clic vers
     la fiche. */
  document.addEventListener('click', function (e) {
    var f = e.target.closest && e.target.closest('[data-rdg-fleche]');
    if (!f) return;
    e.preventDefault();
    e.stopPropagation();
    var carte = f.closest('.hdt-card-product');
    var c = carte && carte.querySelector(SEL);
    var piste = c && c.querySelector(PISTE);
    if (!piste) return;
    hydrater(c);
    piste.scrollBy({ left: Number(f.getAttribute('data-rdg-fleche')) * piste.clientWidth, behavior: 'smooth' });
  }, true);

  /* Survol d'un rectangle de coloris : la 1re vue prend la photo de ce coloris
     et la piste revient au debut. La photo reste apres le survol (comme sur la
     reference) ; le clic ouvre la fiche sur ce coloris. */
  document.addEventListener('pointerover', function (e) {
    var r = e.target.closest && e.target.closest('.rdg-cc-coloris__c');
    if (!r || r.classList.contains('is-actif')) return;
    var carte = r.closest('.hdt-card-product');
    var vue = carte && carte.querySelector('.hdt-card-product__media--main');
    if (!vue) return;
    vue.srcset = r.getAttribute('data-rdg-vsrcset');
    vue.src = r.getAttribute('data-rdg-vimg');
    var autres = carte.querySelectorAll('.rdg-cc-coloris__c.is-actif');
    for (var i = 0; i < autres.length; i++) autres[i].classList.remove('is-actif');
    r.classList.add('is-actif');
    var piste = carte.querySelector(PISTE);
    if (piste && piste.scrollLeft) piste.scrollTo({ left: 0, behavior: 'smooth' });
  }, { passive: true });

  /* Au retour d'un filtre, la grille est neuve : les cartes reprennent a la vue
     1 (scrollLeft 0), donc l'etat par defaut du CSS est deja le bon. Rien a
     recalculer ici — c'est le benefice de n'avoir aucun etat par carte. */
})();
